export const displayConvertedDepth = (depth, getUserUnits, toCustomUnit=null) => {
  const { value: depthConverted, label: depthUnitsLabel } = toCustomUnit==='millimeters'
    ? getUserUnits(depth, 'inches', 'depth', {}, 'centimeters')
    : getUserUnits(depth, 'inches', 'depth');
  const depthLabel = depthUnitsLabel === 'in' ? 'in.' : depthUnitsLabel;
  const convertedDepth = `${Math.round(depthConverted)}`;
  return `${convertedDepth} ${depthLabel}`;
};
